import { Component, EventEmitter, OnDestroy, Output, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";

import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-manage-asset",
	templateUrl: "./manage-asset.component.html",
	styleUrls: ["./manage-asset.component.scss"],
	imports: [RouterLink, RouterLinkActive, RouterOutlet]
})
export class ManageAssetComponent implements OnDestroy {
	private api = inject(ApiService);
	private activatedRoute = inject(ActivatedRoute);

	@Output()
	UpdateTree: EventEmitter<void> = new EventEmitter<void>();

	public asset: APIResults.Asset;

	constructor() {
		this.activatedRoute.params.pipe(takeUntilDestroyed()).subscribe((params) => {
			this.RefreshAsset(Number(params["assetid"]));
		});
	}

	ngOnDestroy() {
		this.updateTreeSubscription?.unsubscribe();
	}

	public async RefreshAsset(asset_id: number) {
		this.asset = undefined;
		this.asset = await this.api.GetAsset(asset_id);
	}

	private activeRouteComponent: any;
	private updateTreeSubscription: any;
	public updateRouterOutlet(routecomponent?: any) {
		this.updateTreeSubscription?.unsubscribe();
		if (routecomponent) {
			this.activeRouteComponent = routecomponent;
		}
		if (this.activeRouteComponent) {
			if (this.activeRouteComponent.UpdateTree) {
				this.updateTreeSubscription = this.activeRouteComponent.UpdateTree.subscribe(async () => {
					this.UpdateTree.emit();
				});
			}
			this.activeRouteComponent.asset = this.asset;
		}
	}
}
